import React, { useRef, useEffect } from 'react';
import { Input, Form } from '@ss/mtd-react';
import { Select } from '@block/plug';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import { getEnumByCategory } from '@service/resumeDetail';
import ModuleView from '../../ModuleView';

const FormItem = Form.Item;

// 仅校招
function Paper(props) {
  const formRefs = useRef<any[]>([]);

  const { data } = props;
  const { campusResumeDetail, campusResumeFormRefStore } = useRootStore();

  const store = campusResumeDetail;
  const storeRef = campusResumeFormRefStore;

  useEffect(() => {
    storeRef.changeRef('resumeThesisListRef', formRefs.current);
  }, [data, data?.length]);

  const handleValueChange = (index: string, formItemKey: string, formItemValue: any) => {
    switch (formItemKey) {
      case 'thesisLevelName': {
        store.setResumeThesisList(index, 'thesisLevelName', formItemValue?.name ? formItemValue.name : '');
        store.setResumeThesisList(index, 'thesisLevelCode', formItemValue?.id ? formItemValue.id : '');
        break;
      }
      case 'authorOrderName': {
        store.setResumeThesisList(index, 'authorOrderName', formItemValue?.name ? formItemValue.name : '');
        store.setResumeThesisList(index, 'authorOrderCode', formItemValue?.id ? formItemValue.id : '');
        break;
      }
      default:
        store.setResumeThesisList(index, formItemKey, formItemValue);
    }
  };

  const handleFetchData = async (category: string, filter?: string) => {
    const res = await getEnumByCategory({ category, filter });
    return res;
  };

  return (
    <div className="paper_edit model_edit">
      <div className="model_title">论文</div>
      {data?.map((item, index) => (
        <div className="model_list" key={item.renderId}>
          <Form
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            className="modal_form"
            defaultFieldsValue={item}
            onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(index, formItemKey, formItemValue)}
          >
            <FormItem formItemKey="thesisName" span="11" labelWidth={0} required message="请填写论文名称">
              <div className="label">
                论文名称<span className="icon">*</span>
              </div>
              <Input toFormItem size="large" placeholder="请输入论文名称" maxLength={1000} />
            </FormItem>
            <FormItem formItemKey="thesisLevelName" span="11" labelWidth={0} required message="请填写发表渠道">
              <div className="label">
                发表渠道<span className="icon">*</span>
              </div>
              <Select
                toFormItem
                size="large"
                placeholder="请选择"
                labelField="name"
                keyField="id"
                onFetchData={(filter) => handleFetchData('thesisLevel', filter)}
              />
            </FormItem>
            <FormItem formItemKey="authorOrderName" span="11" labelWidth={0} required message="请填写作者顺序">
              <div className="label">
                作者顺序<span className="icon">*</span>
              </div>
              <Select
                toFormItem
                size="large"
                placeholder="请选择"
                labelField="name"
                keyField="id"
                onFetchData={() => handleFetchData('authorOrder')}
              />
            </FormItem>
            <FormItem
              formItemKey="influenceFactor"
              span="11"
              labelWidth={0}
              rules={[
                {
                  validator: (rule, tmp, callback) => {
                    const value = tmp?.trim();
                    if (value && !/^[0-9]\d{0,36}(\.\d{1,3})?$|^0(\.\d{1,3})?$/.test(value)) {
                      callback('影响因子有误，请检查');
                      return;
                    }
                    callback();
                  },
                },
              ]}
            >
              <div className="label">影响因子</div>
              <Input toFormItem size="large" placeholder="请输入影响因子" />
            </FormItem>
            <FormItem formItemKey="thesisUrl" span="11" labelWidth={0}>
              <div className="label">论文链接</div>
              <Input toFormItem size="large" placeholder="请选择" />
            </FormItem>
          </Form>
          <div className="delete-list">
            <div onClick={() => store.deleteResumeList('resumeThesisList', index)}>删除这段信息</div>
          </div>
        </div>
      ))}
      <div
        className="list_add"
        onClick={() => {
          store.addResumeList('resumeThesisList');
        }}
      >
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加论文
      </div>
    </div>
  );
}

export default ModuleView(observer(Paper), 'paper');
